import { styled } from '@naan/stitches.config';

export const SectionBreak = styled('div', {
  height: 40,
  '@small': {
    height: 56,
  },
  '@medium': {
    height: 80,
  },
});

export const SmallGap = styled('div', {
  height: 24,
  '@small': {
    height: 40,
  },
  '@medium': {
    height: 40,
  },
});

export const MediumGap = styled('div', {
  height: 40,
  '@small': {
    height: 56,
  },
  '@medium': {
    height: 56,
  },
});

export const LargeGap = styled('div', {
  height: 40,
  '@small': {
    height: 56,
  },
  '@medium': {
    height: 80,
  },
});

export const SectionEnds = styled('div', {
  height: 8,
  '@small': {
    height: 16,
  },
});
